import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  open(e) {
    e.preventDefault()
    this.dialogTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden") // Prevent scrolling
  }

  close(e) {
    e.preventDefault()
    this.dialogTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }
}
